import { Paragraph, Text } from '@zillow/constellation-10';
import { centsToDollars } from '@common/paymentsUtils/currencyUtils';

interface FeeModuleProps {
  fee: number;
}

const FeeModule = ({ fee }: FeeModuleProps) => (
  <>
    <Paragraph textStyle="body-bold">Card fee</Paragraph>
    <Text>{centsToDollars(fee)}</Text>
  </>
);

export default FeeModule;
